<script setup lang="ts">
import { ref, watch } from 'vue';
import moment from 'moment';
import { useActivityStore } from '@/stores/activity';
import {
  Header
} from '@/components/common/';
import { getActionFromSubtype } from './ActivityHelpers';
import RenderActivity from './RenderActivity.vue';
import Paginator from 'primevue/paginator';
import ProgressSpinner from 'primevue/progressspinner';
import { type PaginatorData } from '../common/interfaces/PaginatorData';
import { useStudyStore } from '@/stores/study';

const activityStore = useActivityStore();
const currentPage = ref<number>(0);
activityStore.getActivityActions(currentPage.value);

const onPageChange = (event: PaginatorData) => {
  currentPage.value = event.page;
  activityStore.getActivityActions(currentPage.value);
};

const studyStore = useStudyStore();
watch(
  () => studyStore.selectedStudy,
  (newId, oldId) => {
    if (oldId && newId !== oldId) {
      currentPage.value = 0;
      activityStore.getActivityActions(currentPage.value);
    }
  }
);
</script>

<template>
  <div class="activity">
    <div class="header">
      <Header title="Activity Monitor"></Header>
    </div>
    <div class="activity-container">
      <div v-if="activityStore.isActvityLoading.isFinished">
        <div v-for="activity in activityStore.activityList"
          :key="activity.identifier"
          class="activity-row">
          <div class="activity-row-first-div">
            {{ activity.activityOwner.name }}({{ activity.activityOwner.email }})
            {{ getActionFromSubtype(activity.subType) }}
            <RenderActivity :activity="activity" />
          </div>
          <div class="activity-row-second-div">
            {{ moment(activity.createdAt).format("MM-DD-yyyy hh:mm a") }}
          </div>
        </div>
      </div>
      <div v-if="activityStore.isActvityLoading.isLoading" class="progress-container">
        <ProgressSpinner style="width: 32px;" strokeWidth="4"/>
      </div>
      
      <div class="pagination-bar">
        <Paginator :rows="10"
          :totalRecords="activityStore.activityCount"
          template="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          @page="onPageChange" />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
:deep(.activity-row-first-div b) {
  font-weight: bold;
}
.activity {
  padding: 48px 100px 40px 80px;
  height: 100%;
}
.activity-container {
  color: #272a2e;
  line-height: 20px;
  font-size: 14px;
  max-width: 900px;
  min-width: 800px;
  height: auto;
  padding: 40px;
  justify-content: space-between;
  border-width: 1px;
  border-color: #d9dee4;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 0 0 1px #ebeff2, 0 1px 10px 1px rgba(15, 15, 15, 0.05),
    0 1px 3px 1px rgba(15, 15, 15, 0.05);
}
.activity-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}
.pagination-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 8px;
}
.custom-button {
  margin-left: 8px;
}
.progress-container {
  display: flex;
  justify-content: center;
}
</style>
